import { useEffect, useState } from 'react';
import type { DeliveryAddress } from '@/types';

interface AddressDetails {
  description?: string;
  label: string;
  placeId: string;
  location: {
    lat: number;
    lng: number;
  };
  gmaps: any;
}

export const useAddressTransform = (addressDetails: AddressDetails | null | undefined) => {
  const [deliveryAddress, setDeliveryAddress] = useState<DeliveryAddress | null>(null);

  useEffect(() => {
    if (!addressDetails) {
      setDeliveryAddress(null);
      return;
    }

    const components = addressDetails.gmaps?.address_components || [];

    const getComponent = (types: string[]) => {
      const comp = components.find((c: { types: string[] }) =>
        types.some(t => c.types.includes(t))
      );
      return comp?.long_name || '';
    };

    const address: DeliveryAddress = {
      formatted: addressDetails.gmaps?.formatted_address || addressDetails.description || addressDetails.label,
      street: `${getComponent(['street_number'])} ${getComponent(['route'])}`.trim() || addressDetails.label,
      suburb: getComponent(['locality', 'sublocality', 'sublocality_level_1']) || '',
      state: getComponent(['administrative_area_level_1']) || '',
      postcode: getComponent(['postal_code']) || '',
      latitude: addressDetails.location?.lat || 0,
      longitude: addressDetails.location?.lng || 0,
      placeId: addressDetails.placeId,
    };

    setDeliveryAddress(address);
  }, [addressDetails]);

  return deliveryAddress;
};
